/**
* SwiperSlider
* @description Web component used to create sliders, configurable with data-options attribute.
*/

(async () => {
  
  if (!customElements.get('swiper-slider')) {
    
    const { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay } = await import("swiper");
    
    Swiper.use([
      Navigation,
      Pagination,
      Scrollbar,
      Autoplay
    ]);
    
    class SwiperSlider extends HTMLElement {
      constructor() {
        super();
        
        this.swiper = this;
        this.swiperOptions = {
          threshold: 10
        };
        
        if(!this.swiper) {
          return;
        }
        
        // Check if we have extra options on the HTML
        if (this.swiper?.dataset?.options) {
          const options = JSON.parse(this.swiper.dataset.options);
          if (options) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...options
            }
          }
        }
        
        /**
        * Listen to extra events when in Shopify editor
        */
        if (Shopify.designMode) {

          // Update the swiper when the section event is triggerd
          window.addEventListener('shopify:section:load', (event) => {
            this.swiper.update();
            if (this.swiperOptions.navigation) {
              this.swiper.navigation.init();
              this.swiper.navigation.update();
            }
          });
          
          // When on block select go to the slide in front-end
          window.addEventListener('shopify:block:select', (event) => {
            this.swiper.update();
            if (this.swiperOptions.navigation) {
              this.swiper.navigation.init();
              this.swiper.navigation.update();
            }
            this.handleBlockSelect(event);
          });

          // When on block deselect go to the slide in front-end
          window.addEventListener('shopify:block:deselect', (event) => {
            this.swiper.update();
            if (this.swiperOptions.navigation) {
              this.swiper.navigation.init();
              this.swiper.navigation.update();
            }
            this.handleBlockSelect(event);
          });

        }
        
        this.swiper = new Swiper(this.swiper, this.swiperOptions);
        
      }
      
      /**
      * Handles the theme editor block change/edit event
      * @param {Object} event
      */
      handleBlockSelect(event) {

        // Check if the slide index is set
        if (!("swiperSlideIndex" in event.target.dataset)) { return; }

        // Set the slide index based on loop settings or not
        let swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) - 1;
        if(this.swiperOptions.loop) {
          swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) + 1;
        }

        // Slide to slide based on the data attribute from the target
        this.swiper.slideTo(swipeToSlideIndex, 1000);
        
      }
      
    }
    
    window.SwiperSlider = SwiperSlider;
    
    customElements.define('swiper-slider', SwiperSlider);
    
  }
  
})();